



















import FireBaseUtils from '@/libs/FirebaseUtils';
import firebase from 'firebase/app';
import 'firebase/auth';
import Vue from 'vue';

export default Vue.extend({
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    sidebarActive() {
      return this.$store.state.sidebarActive;
    },
    overlayActive() {
      return this.$store.state.overlayActive;
    },
  },
  mounted() {
    // check login
    FireBaseUtils.safeGetUser();
  },
  methods: {
    logout() {
      firebase.auth().signOut();
    },
    controlSidebar() {
      this.$store.commit('updateSidebarActive', !this.sidebarActive);
      this.$store.commit('updateOverlayActive', !this.overlayActive);
    },
  },
});
